import { render, staticRenderFns } from "./section-collapse.vue?vue&type=template&id=befcd8d6&scoped=true"
import script from "./section-collapse.vue?vue&type=script&lang=ts"
export * from "./section-collapse.vue?vue&type=script&lang=ts"
import style0 from "./section-collapse.vue?vue&type=style&index=0&id=befcd8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcd8d6",
  null
  
)

export default component.exports